// vendor modules
import React, { Component } from "react"
import PropTypes from "prop-types"

// components
import { AddressAutocompleteInput } from "shared-web/forms/components/AddressAutocompleteInput"
import { Icon } from "quorumdesign"

class AddressInputFilter extends Component {
    static propTypes = {
        placeholderText: PropTypes.string,
        publishChange: PropTypes.func.isRequired,
        value: PropTypes.string,
    }

    state = {
        inputText: this.props.value || "",
    }

    componentDidUpdate(oldProps) {
        if (this.props.value == null && oldProps.value != null && this.state.inputText) {
            // checks to see if filter was forcibly set to undefined, then
            // clear the value
            this.setState({ inputText: "" })
        }

        if (this.props.value != null && oldProps.value == null && !this.state.inputText) {
            // if the value is changed externally (from URL or default filter)
            // then setState to the new value
            this.setState({ inputText: this.props.value })
        }
    }

    listenForEnter = (e) => {
        return e.key === "Enter" && this.submitText()
    }

    changeInputValue = (e) => {
        this.setState({ inputText: e.target.value })
    }

    submitText = () => {
        this.props.publishChange(this.state.inputText)
    }

    clearValue = () => {
        this.setState({ inputText: "" }, this.submitText)
    }

    onAddressClick = (value) => {
        this.setState({ inputText: value }, this.submitText)
    }

    render() {
        return (
            <div className="filter-container-address-ff-search-design">
                <div className="input-group">
                    <AddressAutocompleteInput
                        inputProps={{
                            className: "form-control input-lg",
                            onChange: this.changeInputValue,
                            onKeyUp: this.listenForEnter,
                            placeholder: this.props.placeholderText,
                            value: this.state.inputText,
                        }}
                        onAddressClick={this.onAddressClick}
                    />
                    <span className="input-search-buttons">
                        {/* ignoring jsx-a11y rules to apply other style changes to the file - should be updated to enforce accessibility */}
                        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
                        <div className="input-group-addon-search" onClick={this.submitText}>
                            <Icon icon="search" fixedWidth={false} />
                        </div>
                        {this.props.value && (
                            /* ignoring jsx-a11y rules to apply other style changes to the file - should be updated to enforce accessibility */
                            /* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
                            <div className="input-group-addon-button" onClick={this.clearValue}>
                                <span className="clear-input-search">
                                    <Icon fixedWidth={false} icon="times" iconFamily="fal" />
                                </span>
                            </div>
                        )}
                    </span>
                </div>
            </div>
        )
    }
}

export default AddressInputFilter
